<template>
  <div class="authClientRoles">
    <el-button
      type="primary"
      size="small"
      class="setAuth"
      @click="setAuthClient"
    >
      授权应用
    </el-button>
    <el-table
      :data="tableDataClient"
      tooltip-effect="light"
      style="width: 100%"
    >
      <el-table-column
        label="应用ID"
        prop="clientId"
        width="240"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
        label="应用名称"
        prop="clientName"
        width="240"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column label="角色" prop="role" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          {{ formatRole(scope.row.role) }}
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="200px"
        align="center"
        class-name="options td-pt3"
      >
        <template slot-scope="scope">
          <span
            class="textBtn"
            @click="handleSetRole(scope.row.id, scope.row.role)"
          >
            授权应用角色
          </span>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      title="授权应用"
      width="660px"
      :visible.sync="dialogAuthClient"
      :close-on-click-modal="false"
    >
      <el-table
        :data="tableDataAllClient"
        tooltip-effect="light"
        style="width: 100%"
        ref="multipleTableClient"
        @selection-change="handleClientSelectionChange"
      >
        <el-table-column type="selection" width="55" :selectable="selectable">
        </el-table-column>
        <el-table-column
          label="应用ID"
          prop="clientId"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          label="应用名称"
          prop="clientName"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
      </el-table>
      <div class="tableTip">{{ mark }}</div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitAuthClient">确 定</el-button>
        <el-button @click="dialogAuthClient = false">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="授权应用角色"
      width="860px"
      :close-on-click-modal="false"
      :visible.sync="dialogSetRoleVisible"
    >
      <el-table
        :data="tableDataRole"
        tooltip-effect="light"
        style="width: 100%"
        ref="multipleTableRole"
        @selection-change="handleRoleSelectionChange"
      >
        <el-table-column type="selection" width="55" :selectable="selectable">
        </el-table-column>
        <el-table-column
          label="角色标识"
          prop="mark"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          label="角色名称"
          prop="roleName"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          label="角色描述"
          prop="roleDesc"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
      </el-table>
      <div v-if="showTips" class="tableTip">{{ mark }}</div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitSetRole">确 定</el-button>
        <el-button @click="dialogSetRoleVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    tableDataClient: {
      type: Array,
      default: () => []
    },
    tableDataAllClient: {
      type: Array,
      default: () => []
    },
    modules: {
      // 判断是哪个模块
      type: String,
      default: () => ""
    },
    showTips: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      dialogAuthClient: false,
      dialogSetRoleVisible: false,
      clientId: "",
      selectedClient: [],
      tableDataRole: [],
      mark: "注：通过继承关系获取的访问权限，需在对应的管理模块中完成取消授权的相关操作。"
    }
  },
  methods: {
    selectable(row) {
      return !(row.authMark === 2 && this.modules === "account")
    },
    // 打开授权应用弹窗
    setAuthClient() {
      this.dialogAuthClient = true
      this.$nextTick(() => {
        // 勾选上已经授权的应用
        this.$refs.multipleTableClient.clearSelection()
        this.tableDataClient.forEach(row => {
          this.$refs.multipleTableClient.toggleRowSelection(row, "selected")
        })
      })
    },
    // 打开授权应用角色弹窗
    handleSetRole(id, role) {
      this.dialogSetRoleVisible = true
      this.clientId = id
      this.tableDataRole = role.map(item => ({
        mark: item.mark,
        roleName: item.name,
        roleDesc: item.description,
        authMark: item.authMark
      }))
      this.$nextTick(() => {
        // 勾选上已经授权的角色
        this.$refs.multipleTableRole.clearSelection()
        this.tableDataRole
          .filter(item => item.authMark)
          .forEach(row => {
            this.$refs.multipleTableRole.toggleRowSelection(row, "selected")
          })
      })
    },
    // 选择应用变化
    handleClientSelectionChange(clientArr) {
      this.selectedClient = clientArr
    },
    // 选择角色变化
    handleRoleSelectionChange(selectRoles) {
      this.selectedRoles = selectRoles
    },
    // 确认授权应用
    submitAuthClient() {
      // 确认授权时，对比当前应用的勾选状态和已经授权的应用，找出需要移除的应用和需要添加的应用
      let addCIds = this.selectedClient
        .filter(
          item =>
            !this.tableDataClient.find(innerItem => item.id === innerItem.id)
        )
        .map(item => item.id)
      let remCIds = this.tableDataClient
        .filter(
          item =>
            !this.selectedClient.find(innerItem => innerItem.id === item.id)
        )
        .map(item => item.id)
      if (addCIds.length === 0 && remCIds.length === 0) {
        this.dialogAuthClient = false
        return false
      }
      this.$emit("postDepartClients", { addCIds, remCIds })
    },
    // 确认授权角色，逻辑与应用一样
    submitSetRole() {
      if(this.tableDataRole.length < 1 || !this.selectedRoles) {
        this.dialogSetRoleVisible = false
        return false
      }
      let addRoleMarks = this.selectedRoles
        .filter(
          item =>
            !this.tableDataRole
              .filter(role => role.authMark)
              .find(innerItem => item.mark === innerItem.mark)
        )
        .map(item => item.mark)
      let remRoleMarks = this.tableDataRole
        .filter(
          item =>
            item.authMark &&
            !this.selectedRoles.find(innerItem => innerItem.mark === item.mark)
        )
        .map(item => item.mark)
      // console.log(this.addRoleMarks)
      // console.log(this.remRoleMarks)
      if (addRoleMarks.length === 0 && remRoleMarks.length === 0) {
        this.dialogSetRoleVisible = false
        return false
      }
      this.$emit("putDepAuthCliRoles", {
        clientId: this.clientId,
        addRoleMarks,
        remRoleMarks
      })
    },
    // 格式化角色展示信息
    formatRole(roles) {
      return roles.length === 0
        ? ""
        : roles
            .filter(item => item.authMark)
            .map(item => item.name)
            .join("，")
    }
  }
}
</script>

<style lang="scss">
.authClientRoles {
  .el-button {
    &.setAuth {
      margin-bottom: 15px;
    }
  }
  .tableTip {
    font-size: 12px;
    margin-top: 4px;
  }
}
</style>
